const logos = [
  {
    title: `Sadler's Wells`,
    img: `https://i.imgur.com/dewG4QC.png`,
  },
  {
    title: `Fuel Theatre`,
    img: `https://i.imgur.com/5IBOyOb.png`,
  },
  {
    title: `Barbican`,
    img: `https://i.imgur.com/B9YrWy4.png`,
  },
  {
    title: `SportsBeat`,
    img: `https://i.imgur.com/DLC6BUv.png`,
  },
  {
    title: `Harper's Bazaar`,
    img: `https://i.imgur.com/KmnwVSF.png`,
  },
  {
    title: `British Basketball League`,
    img: `https://i.imgur.com/dgFYJjy.png`,
  },
  {
    title: `The Cogency`,
    img: `https://i.imgur.com/IQFiFMk.png`,
  },
  {
    title: `Candoco Dance Company`,
    img: `https://i.imgur.com/B7HJFK5.png`,
  },
  {
    title: `Birmingham International Dance Festival`,
    img: `https://i.imgur.com/WUWhsLn.jpg`,
  },
  {
    title: `Royal Opera House`,
    img: `https://i.imgur.com/vp1TDcu.png`,
  },
  {
    title: `dn&co`,
    img: `https://i.imgur.com/7d6PDVe.png`,
  },
  {
    title: `Siobhan Davies Dance`,
    img: `https://i.imgur.com/SLPOS6s.png`,
  },
  {
    title: `Cricket World Cup`,
    img: `https://i.imgur.com/YnVUoZa.png`,
  },
  {
    title: `Greenwich+Docklands International Festival`,
    img: `https://i.imgur.com/Y3iDyDg.png`,
  },
  {
    title: `Garsington Opera`,
    img: `https://i.imgur.com/Q6zxHAI.png`,
  },
  {
    title: `Secret Garden Party`,
    img: `https://i.imgur.com/5VdsO6s.jpg`,
  },
  {
    title: `Opera Holland Park`,
    img: `https://i.imgur.com/G6GqxuU.png`,
  },
  {
    title: `Asian Business Park`,
    img: `https://i.imgur.com/N66pMUG.png`,
  },
  {
    title: `Rambert`,
    img: `https://i.imgur.com/28Y3WSp.jpg`,
  },
  {
    title: `Coca-Cola`,
    img: `https://i.imgur.com/29Rcaw8.png`,
  },
  {
    title: `DanceXchange`,
    img: `https://i.imgur.com/N5ha9Vq.png`,
  },
  {
    title: `Royal Docks`,
    img: `https://i.imgur.com/NxO0dGX.png`,
  },
  {
    title: `Yankee Candle`,
    img: `https://i.imgur.com/6A21fhL.png`,
  },
  {
    title: `Whats On Stage`,
    img: `https://i.imgur.com/zNiI80P.png`,
  },
  {
    title: `Women's Prize for Fiction`,
    img: `https://i.imgur.com/1Tn1UuP.jpg`,
  },
  {
    title: `England Cricket Board`,
    img: `https://i.imgur.com/UDn4F0a.png`,
  },
  {
    title: `Tonic Theatre`,
    img: `https://i.imgur.com/4KTHLlU.png`,
  },
  {
    title: `Air China`,
    img: `https://i.imgur.com/vJnWGyB.png`,
  },
  {
    title: `SAS`,
    img: `https://i.imgur.com/jYskvTF.png`,
  },
  {
    title: `SportsAid`,
    img: `https://i.imgur.com/Dn7gTnX.jpg`,
  },
  {
    title: `BBC Children in Need`,
    img: `https://i.imgur.com/1V5gn4Z.png`,
  },
  {
    title: `Club Wembley`,
    img: `https://i.imgur.com/YLPHXtI.png`,
  },
  {
    title: `All England Club`,
    img: `https://i.imgur.com/gQJrBnT.jpg`,
  },
  {
    title: `British Rowing`,
    img: `https://i.imgur.com/JRB7fS5.png`,
  },
  {
    title: `SSE`,
    img: `https://i.imgur.com/gfYKqJ0.jpg`,
  },
  {
    title: `Hayemaker Boxing`,
    img: `https://i.imgur.com/YaSZOOf.jpg`,
  },
  {
    title: `Purple Bricks`,
    img: `https://i.imgur.com/leGNQxy.png`,
  },
  {
    title: `Campari`,
    img: `https://i.imgur.com/HeHLoGu.png`,
  },
  {
    title: `Greene King`,
    img: `https://i.imgur.com/FBBXx4U.png`,
  },
  {
    title: `British Athletics`,
    img: `https://i.imgur.com/ClYWm0f.png`,
  },
  {
    title: `Nederlandse Dansdagen`,
    img: `https://i.imgur.com/7tAD2oQ.jpg`,
  },
  {
    title: `Land Rover`,
    img: `https://i.imgur.com/yRy35eR.jpg`,
  },
  {
    title: `14-18 Now`,
    img: `https://i.imgur.com/orw2GEz.png`,
  },
  {
    title: `British Gymnastics Foundation`,
    img: `https://i.imgur.com/Nj6aPeh.jpg`,
  },
  {
    title: `Singapore Dance Theatre`,
    img: `https://i.imgur.com/X6Ag1ef.png`,
  },
  {
    title: `Lifestyle Sports`,
    img: `https://i.imgur.com/g0fQVZc.jpg`,
  },
  {
    title: `British Swimming`,
    img: `https://i.imgur.com/qElgzKK.jpg`,
  },
  {
    title: `Project Arts Centre`,
    img: `https://i.imgur.com/z2SPGDX.png`,
  },
];

export default logos;
